import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { RedirectService, RouteHelperService } from '@app/shared/services';
import { AuthService } from '@app/api/api-services/auth.service';
import { EidAuthService } from '../services/eid-auth.service';

@Component({
  selector: 'a360-eid-appswitch',
  template: '',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class EidAppswitchComponent implements OnInit {
  constructor(
    private readonly eidAuthService: EidAuthService,
    private readonly authService: AuthService,
    public readonly routeHelper: RouteHelperService,
    public readonly redirectService: RedirectService
  ) {}

  ngOnInit(): void {
    if (this.authService.isAuthenticated()) {
      this.redirectService.handleLogin();
      return;
    }
    this.checkAuth();
  }

  private checkAuth(): void {
    const redirectUrl = this.routeHelper.getQueryParam('redirectURL');
    sessionStorage.setItem('redirectURL', redirectUrl);
    this.eidAuthService.redirectToEidLogin();
  }
}
